import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "BulkTransferEnginePostBoot" */ './lazyIndex'),
    { name: 'BulkTransferEnginePostBoot' }
);

export const lazyCanCloseMonarchWithPstBulkExportInProgress: LazyAction<
    typeof lazyIndex.canCloseMonarchWithPstBulkExportInProgress,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.canCloseMonarchWithPstBulkExportInProgress);

export const lazyCanCloseMonarchWithPstBulkImportInProgress: LazyAction<
    typeof lazyIndex.canCloseMonarchWithPstBulkImportInProgress,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.canCloseMonarchWithPstBulkImportInProgress);

export const lazyRunBulkTransferPostBootTasks: LazyAction<
    typeof lazyIndex.runBulkTransferPostBootTasks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.runBulkTransferPostBootTasks);

export const BulkImportExportDialogs: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.BulkImportExportDialogs
);
